export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_3.036c401e.jpg";